import { BellRinging, Book, Calendar, Chat, Exam, GraduationCap, House,  MonitorPlay,  Student,  UserSquare, YoutubeLogo } from "phosphor-react";
import { IMenuLink } from "./MenuUserLinks";

const menuLinks: IMenuLink[] = [
  {
    "title": 'Dashboard',
    "location": '/',
    "icon": House,
    visible: true,
  },
  {
    "title": 'Alunos',
    "location": '/alunos',
    "icon": UserSquare,
    visible: true,
  },
  {
    "title": 'Módulos',
    "location": '/modulos',
    "icon": YoutubeLogo,
    visible: true,
  },
  {
    "title": 'Plano de Estudos',
    "location": '/plano-de-estudos',
    "icon": Student,
    visible: true,
  },
  {
    "title": 'Vestibulares',
    "location": '/vestibulares',
    "icon": GraduationCap,
    visible: true,
  },
  // {
  //   "title": 'Cursos Extras',
  //   "location": '/cursos-extras',
  //   "icon": MonitorPlay,
  //   visible: true,
  // },
  {
    "title": 'E-books',
    "location": '/materiais',
    "icon": Book,
    visible: true,
  },
  {
    "title": 'Simulados',
    "location": '/simulados',
    "icon": Exam,
    visible: true,
  },
  {
    "title": 'Calendário',
    "location": '/calendario',
    "icon": Calendar,
    visible: true,
  },
 /*  {
    "title": 'Avisos',
    "location": '/avisos',
    "icon": BellRinging,
    visible: true,
  }, */
  {
    "title": 'Artigos do suporte',
    "location": '/suporte',
    "icon": Chat,
    visible: true,
  },
]

export default menuLinks;